"use client";

import { useRef, useState } from "react";
import type { Swiper as SwiperType } from "swiper";
import ReviewSlider from "./review-slider";

interface ClutchReviewProps {
  data?: any;
}

const ClutchReview = ({ data }: ClutchReviewProps) => {
  const swiperRef = useRef<SwiperType | null>(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const testimonials = data?.testimonialCards || [];

  return (
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-0">
      <div className="container sm:!pr-0">
        <div className="flex flex-col xl:flex-row xl:gap-[40px]   relative">
          {/* Left Side */}
          <div className="max-w-[550px] w-full mb-[32px] xl:max-w-[350px] xl:shrink-0">
            <h2 className="xl:text-[48px] xl:leading-[62.4px] lg:text-[40px] lg:leading-[52px] text-[30px] leading-[39px] tracking-[1px] font-bold text-primary-text md:text-left text-center">
              {data?.title}
            </h2>

            {testimonials.length > 0 && (
              <div className="absolute bottom-0 xl:flex items-center gap-4 hidden cursor-pointer">
                <button
                  onClick={() => swiperRef.current?.slidePrev()}
                  className="cursor-pointer flex h-11 w-11 items-center justify-center border border-[#D5E7F6] bg-white transition hover:border-[#0086E6]"
                >
                  <svg width="20" height="20" fill="none">
                    <path
                      d="M8.5 5L3.5 10L8.5 15"
                      stroke="#0B1B2B"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.5 10H4"
                      stroke="#0B1B2B"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>

                <span className="text-[18px] font-bold text-[#111]">
                  {currentSlide}/{testimonials.length}
                </span>

                <button
                  onClick={() => swiperRef.current?.slideNext()}
                  className="cursor-pointer flex h-11 w-11 items-center justify-center border border-[#0086E6] bg-white transition hover:bg-[#0086E6] group"
                >
                  <svg width="20" height="20" fill="none">
                    <path
                      d="M11.5 5L16.5 10L11.5 15"
                      className="stroke-[#0086E6] group-hover:stroke-white"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.5 10H16"
                      className="stroke-[#0086E6] group-hover:stroke-white"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>

          {/* Right Side */}
          <div className="min-w-0 flex-1 overflow-hidden">
            <ReviewSlider
              testimonials={testimonials}
              swiperRef={swiperRef}
              onSlideChange={setCurrentSlide}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClutchReview;
